import { z } from 'zod';

export const MaterialRow = z.object({
  id: z.number().int().positive(),
  file: z.string().nullable(),
  recommend: z.boolean(),
  is_default: z.boolean(),
  public: z.boolean(),
  sort: z.number().int().min(0),
  roll_width_cm: z.number().int().positive(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});
export type Material = z.infer<typeof MaterialRow>;

export const MATERIALS: readonly Material[] = [
  {
    id: 1,
    file: 'materials/matt-vinyl.jpg',
    recommend: true,
    is_default: true,
    public: true,
    sort: 1,
    roll_width_cm: 50,
    created_at: '2026-01-01T00:00:00.000Z',
    updated_at: '2026-01-01T00:00:00.000Z',
  },
  {
    id: 2,
    file: 'materials/eco-paper.jpg',
    recommend: false,
    is_default: false,
    public: true,
    sort: 2,
    roll_width_cm: 100,
    created_at: '2026-01-01T00:00:00.000Z',
    updated_at: '2026-01-01T00:00:00.000Z',
  },
  {
    id: 3,
    file: 'materials/satin.jpg',
    recommend: true,
    is_default: false,
    public: true,
    sort: 3,
    roll_width_cm: 50,
    created_at: '2026-01-01T00:00:00.000Z',
    updated_at: '2026-01-01T00:00:00.000Z',
  },
  {
    id: 4,
    file: 'materials/structural-canvas.jpg',
    recommend: false,
    is_default: false,
    public: true,
    sort: 4,
    roll_width_cm: 100,
    created_at: '2026-01-01T00:00:00.000Z',
    updated_at: '2026-01-01T00:00:00.000Z',
  },
  {
    id: 5,
    file: 'materials/premium-textile.jpg',
    recommend: true,
    is_default: false,
    public: true,
    sort: 5,
    roll_width_cm: 130,
    created_at: '2026-01-01T00:00:00.000Z',
    updated_at: '2026-01-01T00:00:00.000Z',
  },
] as const;

MATERIALS.forEach((m) => MaterialRow.parse(m));
